import {
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGOUT,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  USER_VIEW_REQUEST,
  USER_VIEW_SUCCESS,
  USER_VIEW_FAIL,
  VIEW_ACCREDITED_INVESTORS,
  VIEW_ACCREDITED_INVESTORS_FAIL,
  VIEW_ACCREDITED_INVESTORS_SUCCESS,
  VIEW_COUNTRY_DETAILS,
  VIEW_COUNTRY_DETAILS_FAIL,
  VIEW_COUNTRY_DETAILS_SUCCESS,
  SAVE_CURRENCY_DETAILS,
  SAVE_CURRENCY_DETAILS_FAIL,
  SAVE_CURRENCY_DETAILS_SUCCESS,
  USER_VIEW_INVESTMENT_SUCCESS,
  USER_VIEW_INVESTMENT_REQUEST,
  USER_VIEW_INVESTMENT_FAIL,
  VIEW_FOLLOWER_REPORT_SUCCESS,
  VIEW_FOLLOWER_REPORT_REQUEST,
  VIEW_FOLLOWER_REPORT_FAIL,
} from "../constants/adminConstants";

export const adminLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_REQUEST:
      return { loading: true };
    case ADMIN_LOGIN_SUCCESS:
      return { loading: false, user: action.payload };
    case ADMIN_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case ADMIN_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const forgotpasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_REQUEST:
      return { loading: true };
    case FORGOT_PASSWORD_SUCCESS:
      return { loading: false, password: action.payload };
    case FORGOT_PASSWORD_FAIL:
      return { loading: false, error: action };
    default:
      return state;
  }
};

export const resetpasswordReducer = (state = {}, action) => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return { loading: true };
    case RESET_PASSWORD_SUCCESS:
      return { loading: false, newpassword: action.payload };
    case RESET_PASSWORD_FAIL:
      return { loading: false, error: action };
    default:
      return state;
  }
};

export const userViewReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_VIEW_REQUEST:
      return { loading: true };
    case USER_VIEW_SUCCESS:
      return { loading: false, user: action.payload };
    case USER_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const accreditedInvestorReducer = (state = {}, action) => {
  switch (action.type) {
    case VIEW_ACCREDITED_INVESTORS:
      return { loading: true };
    case VIEW_ACCREDITED_INVESTORS_SUCCESS:
      return { loading: false, user: action.payload };
    case VIEW_ACCREDITED_INVESTORS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//GET-COUNTRY-LIST-REDUCER
export const countryListReducer = (state = {}, action) => {
  switch (action.type) {
    case VIEW_COUNTRY_DETAILS:
      return { loading: true };
    case VIEW_COUNTRY_DETAILS_SUCCESS:
      return { loading: false, countryList: action.payload };
    case VIEW_COUNTRY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//get-currency-list-reducer
export const currencyListReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_CURRENCY_DETAILS:
      return { loading: true };
    case SAVE_CURRENCY_DETAILS_SUCCESS:
      return { loading: false, currencyList: action.payload };
    case SAVE_CURRENCY_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

//Get-user-investment-details
export const userInvestmentViewReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_VIEW_INVESTMENT_REQUEST:
      return { loading: true };
    case USER_VIEW_INVESTMENT_SUCCESS:
      return { loading: false, user: action.payload };
    case USER_VIEW_INVESTMENT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const ViewFollowersDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case VIEW_FOLLOWER_REPORT_REQUEST:
      return { loading: true };
    case VIEW_FOLLOWER_REPORT_SUCCESS:
      return { loading: false, followersList: action.payload };
    case VIEW_FOLLOWER_REPORT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
